import { useState } from '@hookstate/core';
import { NavigationContext } from '@layout/navigation/navigation';
import {
  Avatar,
  Empty,
  Line,
  Text,
} from '@pages/Asset/components/Sidebar/components/Data/components/Assignee/Assignee.styles';
import { getUserMembers } from '@services/queries/studios';
import { IUserMember } from '@services/queries/studios/getUserMembers/getUserMembers';
import { getPermissionData } from '@utils';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import ReactTooltip from 'react-tooltip';
import { DateDiv } from './AssigneeInput.styles';
import { ChangeAssignee } from './ChangeAssignee';
import { NeededUserInfo } from './types';

export const DEFAULT_DATE_FORMAT = 'MM/dd/yyyy';

interface OwnProps {
  value: NeededUserInfo | undefined | null;
  handleUserChange: (IUser: Pick<IUserMember, 'name' | 'id'> | null) => void;
  width?: number;
  height?: number;
  borderColor?: string;
  isDisabled?: boolean;
}

export const AssigneeInput = ({
  value,
  handleUserChange,
  width,
  height,
  borderColor,
  isDisabled,
}: OwnProps) => {
  const { role } = useContext(NavigationContext);

  const open = useState(false);

  const assigneePermission = getPermissionData({
    action: 'assignee',
    owner: false,
    role,
    type: '',
  });

  const handleOpen = () => {
    if (isDisabled) return;
    if (assigneePermission.allowed) {
      open.set(true);
    }
  };
  const membersQuery = useQuery(['members', 'Inventory'], getUserMembers);
  return (
    <DateDiv width={width} height={height} borderColor={borderColor}>
      <div
        data-tip={assigneePermission.message}
        data-event={assigneePermission.allowed ? undefined : 'click'}
        data-for="changeDataAssignee"
      >
        {value ? (
          <>
            {membersQuery?.data ? (
              <Line
                onClick={handleOpen}
                blocked={!assigneePermission.allowed || !!isDisabled}
              >
                <Avatar
                  src={
                    membersQuery.data.find(user => user.id === value.id)
                      ?.picture
                  }
                />
                <Text blocked={!assigneePermission.allowed || !!isDisabled}>
                  {value.name}
                </Text>
              </Line>
            ) : (
              <Text
                onClick={handleOpen}
                blocked={!assigneePermission.allowed || !!isDisabled}
              >
                {value.name}
              </Text>
            )}
          </>
        ) : (
          <Empty
            onClick={handleOpen}
            blocked={!assigneePermission.allowed || !!isDisabled}
          >
            Empty
          </Empty>
        )}
      </div>
      <ReactTooltip
        id="changeDataAssignee"
        className="tooltip"
        effect="solid"
        multiline
        disable={assigneePermission.allowed}
        afterShow={() => {
          setTimeout(ReactTooltip.hide, 1000);
        }}
      />

      <ChangeAssignee
        open={open}
        actualUser={value}
        handleUserChange={handleUserChange}
      />
    </DateDiv>
  );
};
